import MuiAccordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { FC } from "react";
import styled from "styled-components";
import { Icon } from "../Icon/Icon";
import { Typography, Variants } from "../Typography/Typography";

export interface Props {
  heading: string;
  headingBackground?: string;
  headingVariant?: Variants;
  isExpanded?: boolean;
  children: React.ReactNode;
  onExpandedChanged?: (
    event: React.SyntheticEvent,
    isExpanded: boolean
  ) => void;
}

export const Accordion: FC<Props> = (props) => {
  const {
    heading,
    headingBackground,
    headingVariant = "titleSmall",
    isExpanded,
    children,
    onExpandedChanged,
  } = props;

  return (
    <MuiAccordion
      disableGutters
      expanded={isExpanded}
      onChange={onExpandedChanged}
      sx={{
        "& .MuiAccordionSummary-root": {
          backgroundColor: headingBackground || "transparent",
          transition: "background-color 0.3s",
        },
      }}
    >
      <AccordionSummary expandIcon={<Icon icon="chevronDown" />}>
        <Heading variant={headingVariant}>{heading}</Heading>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};

const Heading = styled(Typography)`
  margin-right: 1rem;
`;
